export const ANALYTICS_CONSENT_KEY = "licitx_analytics_consent_v1";

const GTM_ID = process.env.REACT_APP_GTM_ID || "GTM-KGQPCWD9";
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

const pushGoogleConsent = (analyticsStorage) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "licitx_consent_update",
        analytics_storage: analyticsStorage,
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
    });
};

const loadGtm = () => {
    if (!GTM_ID || document.getElementById("licitx-gtm")) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const script = document.createElement("script");
    script.id = "licitx-gtm";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
    document.head.appendChild(script);
};

const loadPostHog = () => {
    if (!POSTHOG_KEY || document.getElementById("licitx-posthog")) return;
    const script = document.createElement("script");
    script.id = "licitx-posthog";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `${POSTHOG_HOST.replace(/\/$/, "").replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
    script.onload = () => {
        if (!window.posthog?.init) return;
        window.posthog.init(POSTHOG_KEY, {
            api_host: POSTHOG_HOST,
            person_profiles: "identified_only",
            autocapture: false,
            capture_pageview: true,
            capture_pageleave: true,
            disable_session_recording: true,
            mask_all_text: true,
            mask_all_element_attributes: true,
            persistence: "localStorage",
            respect_dnt: true,
        });
    };
    document.head.appendChild(script);
};

export const enableAnalytics = () => {
    if (window.__licitxAnalyticsLoaded) return;
    window.__licitxAnalyticsLoaded = true;
    pushGoogleConsent("granted");
    loadGtm();
    loadPostHog();
};

export const disableAnalytics = () => {
    pushGoogleConsent("denied");
    if (window.posthog?.opt_out_capturing) window.posthog.opt_out_capturing();
    ["_ga", "_gid", "_gat"].forEach((name) => {
        document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    });
};
